import type { Api } from './api';
import type { Place, Quote } from './types';

/**
 * Quotes are signed for a few minutes; the app reuses one for the same trip while it has at least 45 s left, so
 * home cards, search results and Choose-ride agree on the price without asking the server again.
 */
const cache = new Map<string, Quote>();
const key = (a: Place, b: Place) => `${a.lat.toFixed(5)},${a.lng.toFixed(5)}>${b.lat.toFixed(5)},${b.lng.toFixed(5)}`;
const fresh = (q: Quote) => Date.parse(q.expiresAt) - Date.now() > 45_000;

export function cachedQuote(a: Place, b: Place): Quote | null {
  const q = cache.get(key(a, b));
  return q && fresh(q) ? q : null;
}

const inflight = new Map<string, Promise<Quote>>();
export function getQuote(api: Api, a: Place, b: Place): Promise<Quote> {
  const k = key(a, b);
  const hit = cachedQuote(a, b);
  if (hit) return Promise.resolve(hit);
  const running = inflight.get(k);
  if (running) return running;
  const p = api
    .quote(a, b)
    .then((q) => {
      cache.set(k, q);
      return q;
    })
    .finally(() => inflight.delete(k));
  inflight.set(k, p);
  return p;
}

export const isFresh = fresh;
export const fareFor = (q: Quote | null, t: string) => q?.options.find((o) => o.vehicleType === t)?.farePaise ?? null;
